import React, { useEffect, useState } from "react";
import axios from "axios";
import config from "../../config";
import { useLocation, useNavigate } from "react-router-dom";
import { toast, ToastContainer, Bounce } from "react-toastify";
import { Table, Input, Button, Space, Image, Typography } from "antd";
import { SearchOutlined, PlusOutlined, DeleteOutlined } from "@ant-design/icons";
import SelectUsersExcelButton from "./SelectUsersExcelButton";
import VersionConflictModal from "../Commons/VersionConflictModal";
import {
    extractVersion,
    getVersionConflictMessage,
    isVersionConflict,
} from "../../utils/versionConflict";
const { Text } = Typography;

const PackageForm = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const isUpdateMode = !!location.state?.package;

    const [loading, setLoading] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isOutdated, setIsOutdated] = useState(false);
    const [versionConflict, setVersionConflict] = useState({
        open: false,
        message: "",
    });
    const [isRefreshing, setIsRefreshing] = useState(false);
    const [userPagination, setUserPagination] = useState({ current: 1, pageSize: 5, total: 0 });
    const [coursePagination, setCoursePagination] = useState({ current: 1, pageSize: 5, total: 0 });
    const [userLoading, setUserLoading] = useState(false);
    const [courseLoading, setCoursLoading] = useState(false);

    const [formData, setFormData] = useState({
        packageId: null,
        title: "",
        description: "",
        courseIds: [],
        userIds: [],
        version: 0,
    });

    const [courses, setCourses] = useState([]);
    const [allCourses, setAllCourses] = useState([]);
    const [users, setUsers] = useState([]);
    const [allUsers, setAllUsers] = useState([]);
    const [selectedCourses, setSelectedCourses] = useState([]);
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [userSearchTerm, setUserSearchTerm] = useState("");
    const [selectedCourseDetails, setSelectedCourseDetails] = useState([]);

    const [UserSearchFilters, setUserSearchFilters] = useState({
        username: "",
        personalId: "",
        lastname: "",
        firstname: "",
        phoneNumber: ""
    });
    const [courseSearchFilter, setCourseSearchFilter] = useState({
        title: ""
    });
    const [selectedImage, setSelectedImage] = useState(null);

    const [allreadyHasImage, setAllreadyHasImage] = useState(false);
    const [oldImageName, setOldImageName] = useState("");

    const handleImageChange = (e) => {
        if (e.target.files && e.target.files.length > 0) {
            setSelectedImage(e.target.files[0]);
        }
    };


    const getSelectedCourseDetails = async (pkgCourseIds, allFetchedCourses, coursePagination) => {
        const alreadyFetchedIds = allFetchedCourses.map(c => c.courseId);
        const missingCourseIds = pkgCourseIds
            .map(p => p.courseId)
            .filter(id => !alreadyFetchedIds.includes(id));

        let fetchedCourses = [];
        if (missingCourseIds.length > 0) {
            const filter = missingCourseIds.map(id => `(CourseId=${id})`).join("|");
            console.log({ filter })
            try {
                const response = await axios.get(`${config.apiBaseUrl}/api/Course/getlist`, {
                    params: {
                        page: 1,
                        pageSize: 100,
                        filter
                    },
                    headers: { HeaderKey: config.HeaderKey },
                    withCredentials: true,
                });
                console.log("Fetched missing courses:", response.data?.data.data);
                fetchedCourses = response.data?.data.data || [];
            } catch (error) {
                console.error("Error fetching courses:", error);
            }
        }

  const allCourses = [...allFetchedCourses, ...fetchedCourses];

  return pkgCourseIds
    .map(pkgItem => {
      const found = allCourses.find(c => c.courseId === pkgItem.courseId);
      if (found) {
        return { ...found, order: pkgItem.order };
      }

      return {
        courseId: pkgItem.courseId,
        title: "(loaded from package)",
        teacher: "",
        order: pkgItem.order
      };
    })
    .sort((a, b) => a.order - b.order);
};



    const orderUsersAndCourses = async (selectedUserIds, selectedCourseList, usersList, courseList) => {
        
        const selectedCourseIds = selectedCourseList.map(c => c.courseId);
        const orderedCourses = courseList
            .filter(c => selectedCourseIds.includes(c.courseId))
            .sort((a, b) => {
                const aOrder = selectedCourseList.find(sc => sc.courseId === a.courseId)?.order || 0;
                const bOrder = selectedCourseList.find(sc => sc.courseId === b.courseId)?.order || 0;
                return aOrder - bOrder;
            });
        const remainingCourses = courseList.filter(c => !selectedCourseIds.includes(c.courseId));
        const finalCourses = [...orderedCourses, ...remainingCourses];
        setAllCourses(finalCourses);
        setCourses(finalCourses);

        const filter = selectedUserIds.map(id => `(userID=${id})`).join("|");
        const response = await axios.get(`${config.apiBaseUrl}/api/Users/GetUsersList`, {
            params: { page: 1, pageSize: 5, filter },
            headers: { HeaderKey: config.HeaderKey },
            withCredentials: true
        });

        const selected = response.data.users || [];
        const remaining = usersList.filter(u => !selectedUserIds.includes(u.userID));
        const finalUsers = [...selected, ...remaining];
        setUsers(finalUsers);
        setAllUsers(finalUsers);
    };

    const fetchCoursesWithFilters = async (title = "", page = 1, pageSize = 10) => {
        try {
            setCoursLoading(true);

            let dynamicFilter;
            if (title) {
                dynamicFilter = `title=*${title}/i`;
            }

            const response = await axios.get(
                `${config.apiBaseUrl}/api/Course/getlist`,
                {
                    params: {
                        page, 
                        pageSize,
                        filter: dynamicFilter,
                    },
                    headers: {
                        "HeaderKey": config.HeaderKey
                    },
                    withCredentials: true,
                }
            );
            
            
            const newCourses = response.data.data.data || [];
            const totalCount = response.data.data.count || 0;

            
            setCourses(newCourses);
            setAllCourses(newCourses); 

            setCoursePagination(prev => ({
                ...prev,
                current: page,
                pageSize,
                total: totalCount,
            }));

        } catch (error) {
            toast.error(<p dir="rtl" className="font-custom">جستجو با خطا مواجه شد</p>);
            if (error.response && error.response.status === 401) {
                navigate("/");
            }
        } finally {
            setCoursLoading(false);
        }
    }
    const courseSearch = async () => {
        await fetchCoursesWithFilters(courseSearchFilter.title, 1, coursePagination.pageSize);
    }
    const userSearch = async () => {
        try {
            setUserLoading(true);

            let dynamicFilter;   

            if (UserSearchFilters.username) {
                dynamicFilter = `username=*${UserSearchFilters.username}/i`;
            }

            if (UserSearchFilters.personalId) {
                dynamicFilter = `personalId=*${UserSearchFilters.personalId}/i`;
            }
            if (UserSearchFilters.lastname) {
                dynamicFilter = `lastname=*${UserSearchFilters.lastname}/i`;
            }
            if (UserSearchFilters.firstname) {
                dynamicFilter = `firstname=*${UserSearchFilters.firstname}/i`;
            }
            if (UserSearchFilters.phoneNumber) {
                dynamicFilter = `phoneNumber=*${UserSearchFilters.phoneNumber}/i`;
            }
            const response = await axios.get(
                `${config.apiBaseUrl}/api/Users/GetUsersList`,
                {
                    params: {
                        page: 1,
                        pageSize: 5,
                        filter: dynamicFilter,   
                    },
                    headers: {
                        "HeaderKey": config.HeaderKey
                    },
                    withCredentials: true,
                }
            );
            setUsers(prev => {
                const newUsers = response.data.users;

                const userMap = new Map(prev.map(u => [u.userID, u]));
                newUsers.forEach(user => userMap.set(user.userID, user));

                return Array.from(userMap.values());
            });
            setAllUsers(prev => {
                const newUsers = response.data.users;

                const userMap = new Map(prev.map(u => [u.userID, u]));
                newUsers.forEach(user => userMap.set(user.userID, user));

                return Array.from(userMap.values());
            });
        } catch (error) {
            toast.error(<p dir="rtl" className="font-custom">جستجو با خطا مواجه شد</p>);
            if (error.response && error.response.status === 401) {
                navigate("/");
            }
        } finally {
            setUserLoading(false);

        }
    }

    const fetchUsersWithFilters = async (uname = "", page = 1, pageSize = 5) => {
        try {
            setUserLoading(true);

            const response = await axios.get(
                `${config.apiBaseUrl}/api/Users/GetUsersList`,
                {
                    params: {
                        page,
                        pageSize,
                    },
                    headers: {
                        "HeaderKey": config.HeaderKey,
                    },
                    withCredentials: true,
                }
            );
            setAllUsers(prev => {
                const newUsers = response.data.users;
                const userMap = new Map(prev.map(u => [u.userID, u]));
                newUsers.forEach(user => userMap.set(user.userID, user));

                return Array.from(userMap.values());
            });

            setUsers(prev => {
                const newUsers = response.data.users;

                const userMap = new Map(prev.map(u => [u.userID, u]));
                newUsers.forEach(user => userMap.set(user.userID, user));

                return Array.from(userMap.values());
            });
            setUserPagination(prev => ({
                ...prev,
                current: page,
                pageSize,
                total: response.data.totalCount,
            }));
        } catch (error) {
            toast.error(<p dir="rtl" className="font-custom">جستجو با خطا مواجه شد</p>);
            if (error.response?.status === 401) {
                navigate("/");
            }
        } finally {
            setUserLoading(false);
        }
    };


    useEffect(() => {
        const loadInitialData = async () => {
            setLoading(true);
            try {
                const [usersRes, coursesRes] = await Promise.all([
                    axios.get(`${config.apiBaseUrl}/api/Users/GetUsersList`, {
                        params: { page: userPagination.current, pageSize: userPagination.pageSize },
                        headers: { HeaderKey: config.HeaderKey },
                        withCredentials: true,
                    }),
                    axios.get(`${config.apiBaseUrl}/api/Course/getlist`, {
                        params: { page: coursePagination.current, pageSize: coursePagination.pageSize },
                        headers: { HeaderKey: config.HeaderKey },
                        withCredentials: true,
                    }),
                ]);

                const initialCourses = coursesRes.data.data.data || [];
                const initialUsers = usersRes.data.users || [];
                const totalCourseCount = coursesRes.data.data.count || 0;
                const totalUserCount = usersRes.data.totalCount || 0;


                setCoursePagination(prev => ({ ...prev, total: totalCourseCount }));
                setUserPagination(prev => ({ ...prev, total: totalUserCount }));
                setUsers(initialUsers);
                setAllUsers(initialUsers);
                
                setCourses(initialCourses);
                setAllCourses(initialCourses);

                if (isUpdateMode) {
                    const pkgId = location.state.package?.id;
                    const { data: pkg } = await axios.post(`${config.apiBaseUrl}/api/Package/GetPackage`, pkgId,
                        {
                            headers: { HeaderKey: config.HeaderKey, "Content-Type": "application/json" },

                            withCredentials: true,
                        });
                    setAllreadyHasImage(true);
                    setOldImageName(pkg.imageUrl);
                    const pkgCourseIds = pkg.courseIds || [];

                    const details = await getSelectedCourseDetails(pkgCourseIds, initialCourses); // ✅ await here
                    setSelectedCourseDetails(details);
                    setFormData(f => ({
                        packageId: pkg.id,
                        title: pkg.title,
                        description: pkg.description,
                        userIds: pkg.userIds || [],
                        courseIds: details.map(c => ({
                            courseId: c.courseId,
                            order: c.order
                        })),
                        version: extractVersion(pkg) ?? 0,
                    }));
                    setSelectedUsers(pkg.userIds || []);
                    await orderUsersAndCourses(pkg.userIds, pkg.courseIds, initialUsers, initialCourses);
                }

            } catch (err) {
                console.log(err)
                toast.error("خطا در بارگذاری اطلاعات");
                if (err.response?.status === 401) navigate("/");
            } finally {
                setLoading(false);
            }
        };
        loadInitialData();
    }, [isUpdateMode, location.state, navigate]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleUserSelection = (newSelectedKeys) => {
        setSelectedUsers((prevSelected) => {
            const updated = new Set(prevSelected);

            newSelectedKeys.forEach(key => updated.add(key));

            allUsers.forEach(user => {
                if (!newSelectedKeys.includes(user.userID)) {
                    updated.delete(user.userID);
                }
            });

            const finalSelection = Array.from(updated);

            setFormData(prev => ({ ...prev, userIds: finalSelection }));
           //orderUsersAndCourses(finalSelection, formData.courseIds, users, allCourses);

            return finalSelection;
        });
    };
const handleAddCourse = (courseToAdd) => {
        if (selectedCourseDetails.some(c => c.courseId === courseToAdd.courseId)) {
            toast.info(<p dir="rtl" className="font-custom">این دوره قبلاً انتخاب شده است.</p>);
            return;
        }

        setSelectedCourseDetails(prev => {
            const newOrder = prev.length + 1;
            const newSelected = [...prev, { ...courseToAdd, order: newOrder }];
            
            setFormData(f => ({ 
                ...f, 
                courseIds: newSelected.map(c => ({ courseId: c.courseId, order: c.order })) 
            }));
            
            return newSelected;
        });
    };
const handleRemoveCourse = (courseId) => {
        setSelectedCourseDetails(prev => {
            let updatedList = prev.filter(c => c.courseId !== courseId);
            
            updatedList = updatedList.map((c, index) => ({ ...c, order: index + 1 })); 
            
            setFormData(f => ({ 
                ...f, 
                courseIds: updatedList.map(c => ({ courseId: c.courseId, order: c.order })) 
            }));
            
            return updatedList;
        });
    };
   const handleCourseSelection = (newSelectedKeys, selectedRows) => {
    setSelectedCourses((prevSelected) => {
        const updated = new Set(prevSelected);

        newSelectedKeys.forEach(key => updated.add(key));

        allCourses.forEach(course => {
            if (!newSelectedKeys.includes(course.courseId)) {
                updated.delete(course.courseId);
            }
        });

        const finalSelectedKeys = Array.from(updated);

        const newCourseIds = finalSelectedKeys.map((courseId, index) => ({
            courseId,
            order: index + 1
        }));

        setFormData(prev => ({ ...prev, courseIds: newCourseIds }));
        orderUsersAndCourses(selectedUsers, newCourseIds, allUsers, courses);

        return finalSelectedKeys;
    });
};


    const handleUserSearchChange = (e, column) => {
        const value = e.target.value;
        const filters = { ...UserSearchFilters, [column]: value };
        setUserSearchFilters(filters);

        const filtered = users.filter(user =>
            (!filters.username || user.username?.toLowerCase().includes(filters.username.toLowerCase())) &&
            (!filters.personalId || user.personalId?.toLowerCase().includes(filters.personalId.toLowerCase())) &&
            (!filters.lastname || user.lastname?.toLowerCase().includes(filters.lastname.toLowerCase())) &&
            (!filters.firstname || user.firstname?.toLowerCase().includes(filters.firstname.toLowerCase())) &&
            (!filters.phoneNumber || user.phoneNumber?.toLowerCase().includes(filters.phoneNumber.toLowerCase()))
        );

        setAllUsers(filtered);
    };

    const handleCourseSearchChange = (e, column) => {
        const value = e.target.value;
        const filters = { ...courseSearchFilter, [column]: value };
        setCourseSearchFilter(filters);
        const filtered = courses.filter(course =>
            (!filters.title || course.title?.toLowerCase().includes(filters.title.toLowerCase())) &&
            (!filters.teacher || course.teacher?.toLowerCase().includes(filters.teacher.toLowerCase()))
        );
    };

    const handleOrderChange = (courseId, newOrder) => {
        setSelectedCourseDetails(prev => {
            let updatedList = prev.map((v) =>
                v.courseId === courseId ? { ...v, order: newOrder } : v
            );
            
            updatedList.sort((a, b) => a.order - b.order);
            updatedList = updatedList.map((c, index) => ({ ...c, order: index + 1 }));

            setFormData(f => ({ 
                ...f, 
                courseIds: updatedList.map(c => ({ courseId: c.courseId, order: c.order })) 
            }));
            
            return updatedList;
        });
    };
const moveCourseUp = (courseId) => {
    setSelectedCourseDetails(prev => {
        const index = prev.findIndex(c => c.courseId === courseId);
        if (index <= 0) return prev; 

        const updated = [...prev];
        [updated[index - 1], updated[index]] = [updated[index], updated[index - 1]];

        const normalized = updated.map((c, i) => ({
            ...c,
            order: i + 1
        }));

        setFormData(f => ({
            ...f,
            courseIds: normalized.map(c => ({ courseId: c.courseId, order: c.order }))
        }));

        return normalized;
    });
};

const moveCourseDown = (courseId) => {
    setSelectedCourseDetails(prev => {
        const index = prev.findIndex(c => c.courseId === courseId);
        if (index === -1 || index === prev.length - 1) return prev; // already bottom

        const updated = [...prev];
        [updated[index], updated[index + 1]] = [updated[index + 1], updated[index]];

        const normalized = updated.map((c, i) => ({
            ...c,
            order: i + 1
        }));

        setFormData(f => ({
            ...f,
            courseIds: normalized.map(c => ({ courseId: c.courseId, order: c.order }))
        }));

        return normalized;
    });
};

    const reloadPackageDetails = async () => {
        const pkgId = formData.packageId || location.state?.package?.id;
        if (!pkgId) throw new Error("missing package id");

        const { data: pkg } = await axios.post(
            `${config.apiBaseUrl}/api/Package/GetPackage`,
            pkgId,
            {
                headers: { HeaderKey: config.HeaderKey, "Content-Type": "application/json" },
                withCredentials: true,
            }
        );

        setAllreadyHasImage(!!pkg.imageUrl);
        setOldImageName(pkg.imageUrl);
        setSelectedImage(null);

        const pkgCourseIds = pkg.courseIds || [];
        const details = await getSelectedCourseDetails(pkgCourseIds, allCourses);
        setSelectedCourseDetails(details);
        setFormData({
            packageId: pkg.id,
            title: pkg.title,
            description: pkg.description,
            userIds: pkg.userIds || [],
            courseIds: details.map((c) => ({
                courseId: c.courseId,
                order: c.order,
            })),
            version: extractVersion(pkg) ?? 0,
        });
        setSelectedUsers(pkg.userIds || []);
        await orderUsersAndCourses(pkg.userIds, pkg.courseIds, users, allCourses);
        setIsOutdated(false);
    };

    const handleVersionConflictRefresh = async () => {
        setIsRefreshing(true);
        try {
            await reloadPackageDetails();
            setVersionConflict({ open: false, message: "" });
            toast.success(
                <p dir="rtl" className="font-custom">اطلاعات پکیج بازخوانی شد</p>
            );
        } catch {
            toast.error(<p dir="rtl" className="font-custom">خطا در بازخوانی پکیج</p>);
        } finally {
            setIsRefreshing(false);
        }
    };

    const handleVersionConflictCancel = () => {
        setVersionConflict({ open: false, message: "" });
        navigate("/dashboard/packages");
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (isOutdated) {
            setVersionConflict((prev) => ({ ...prev, open: true }));
            return;
        }
        setIsSubmitting(true);

        try {
            const formDataToSend = new FormData();

            if(formData.packageId){
                formDataToSend.append("packageId", formData.packageId);
            }
            formDataToSend.append("title", formData.title);
            formDataToSend.append("description", formData.description);
            if (isUpdateMode) {
                formDataToSend.append("Version", formData.version ?? 0);
            }
            
            formData.userIds.forEach((userId) => {
                formDataToSend.append("userIds", userId);
            });
            selectedCourseDetails
                .sort((a, b) => a.order - b.order) 
                .forEach((courseObj, index) => {
                    formDataToSend.append(`courseIds[${index}].CourseId`, courseObj.courseId);
                    formDataToSend.append(`courseIds[${index}].Order`, index + 1); 
                });
            formData.courseIds.forEach((courseObj, index) => {
                formDataToSend.append(`courseIds[${index}].CourseId`, courseObj.courseId);
                formDataToSend.append(`courseIds[${index}].Order`, courseObj.order);
            });
            if (selectedImage) {
                formDataToSend.append("image", selectedImage);
            } 
            const url = isUpdateMode
                ? `${config.apiBaseUrl}/api/Package/UpdatePackage`
                : `${config.apiBaseUrl}/api/Package/CreatePackage`;

            const response = await axios.post(url, formDataToSend, {
                headers: {
                    "HeaderKey": config.HeaderKey,
                    "Content-Type": "multipart/form-data"
                },
                withCredentials: true,
            });

            if (response.status === 200) {
                const nextVersion = extractVersion(response.data);
                if (nextVersion != null) {
                    setFormData((prev) => ({ ...prev, version: nextVersion }));
                }

                toast.success(<p dir="rtl" className="font-custom">پکیج با موفقیت ${isUpdateMode ? "آپدیت شد" : "ساخته شد"} </p>);

                setTimeout(() => navigate("/dashboard/packages"), 500);
            } else {
                toast.success(<p dir="rtl" className="font-custom">خطا</p>);

            }
        } catch (error) {
            if (isVersionConflict(error)) {
                setIsOutdated(true);
                setVersionConflict({
                    open: true,
                    message: getVersionConflictMessage(error),
                });
            } else {
                toast.error(<p dir="rtl" className="font-custom">{error.response?.data}</p>);
            }
            if (error.response?.status === 401) navigate("/");
        } finally {
            setIsSubmitting(false);
        }
    };
const selectedCourseColumns = [
    {
        title: 'عنوان دوره',
        dataIndex: 'title',
        key: 'title',
        align: 'right',
        className: 'font-custom',
        render: (text) => <Text strong>{text}</Text>,
    },
    {
        title: 'اولویت',
        className: 'font-custom',
        width: 150,
        key: 'order',
        align: "center",
        render: (_, record) => (
            <input
                type="number"
                value={record.order}
                onChange={(e) => handleOrderChange(record.courseId, parseInt(e.target.value))}
                className="w-16 p-1 border rounded-md text-center"
                min="1"
            />
        ),
    },
    {
        title: "ترتیب",
        key: "actions",
        className: 'font-custom',
        align: "center",
        width: 120,
        render: (_, record) => (
            <div>
                {/* <Button size="small" onClick={() => moveCourseUp(record.courseId)}>⬆️</Button>
                <Button size="small" onClick={() => moveCourseDown(record.courseId)}>⬇️</Button> */}
                <Button className="font-custom" size="small" onClick={() => moveCourseUp(record.courseId)}>بالا</Button>
                <Button className="font-custom" size="small" onClick={() => moveCourseDown(record.courseId)}>پایین</Button>
            </div>
        ),
    },
    {
        title: 'حذف',
        key: 'delete',
        className: 'font-custom',
        align: 'center',
        render: (_, record) => (
            <Button 
                danger
                icon={<DeleteOutlined />}
                onClick={() => handleRemoveCourse(record.courseId)}
                className="font-custom"
            >
                حذف
            </Button>
        ),
    }
];


    return (
        <div className="flex items-center justify-center min-h-screen bg-gray-50 p-6 rtl font-custom">
            <div className="w-full max-w-4xl bg-white p-8 rounded-lg shadow-md">
                <h2 className="text-2xl font-bold text-center mb-6">
                    {isUpdateMode ? "ویرایش پکیج" : "ایجاد پکیج جدید"}
                </h2>

                <form onSubmit={handleSubmit} className="space-y-4">
                    <input
                        type="text"
                        name="title"
                        placeholder="عنوان پکیج"
                        value={formData.title}
                        onChange={handleChange}
                        className="w-full p-3 border rounded-md text-right"
                        required
                        dir="rtl"
                    />
                    <textarea
                        name="description"
                        placeholder="توضیح پکیج"
                        value={formData.description}
                        onChange={handleChange}
                        className="w-full p-3 border rounded-md text-right"
                        rows={4}
                        dir="rtl"
                        required
                    />
                    <div>
                        <label className="block mb-1 font-semibold text-gray-700">تصویر دوره:</label>
                        <input
                            type="file"
                            accept="image/*"
                            onChange={handleImageChange}
                            className="p-2 border rounded-md"
                            placeholder="تصویر دوره الزامیست"
                        />
                        {selectedImage ? (
                            <p className="mt-1 text-sm text-green-600">
                                {selectedImage.name} : تصویر انتخاب شده
                            </p>
                        ) : allreadyHasImage ? (
                            <p className="mt-1 text-sm text-gray-600">
                                تصویر فعلی: {oldImageName}
                            </p>
                        ) : null}
                    </div>
                    <div className="mt-6">
                        <div className="flex items-center my-8">
                            <div className="flex-grow border-t border-gray-300"></div>
                            <h2 className="mx-4 text-xl font-bold text-gray-400 whitespace-nowrap font-custom">
                                دوره های انتخاب شده
                            </h2>
                            <div className="flex-grow border-t border-gray-300"></div>
                        </div>
                        <Table
                            columns={selectedCourseColumns}
                            dataSource={selectedCourseDetails} 
                            rowKey="courseId"
                            pagination={false} 
                            locale={{ emptyText: <Text className="font-custom">دوره ای انتخاب نشده است.</Text> }}
                        />
                    </div>
                    <div className="mt-6">
                        <div className="flex items-center my-8">
                            <div className="flex-grow border-t border-gray-300"></div>
                            <h2 className="mx-4 text-xl font-bold text-gray-400 whitespace-nowrap font-custom">
                            انتخاب دوره ها
                            </h2>
                            <div className="flex-grow border-t border-gray-300"></div>
                        </div>
                        <Table
                            rowSelection={{
                                selectedRowKeys: selectedCourses,
                                onChange: handleCourseSelection,
                            }}
                            columns={[
                                {
                                    title: '',
                                    dataIndex: 'pictureUrl',
                                    key: 'pictureUrl',
                                    align: 'left',
                                    width:20,
                                    className: 'font-custom',
                                    render: (row) => (
                                        <Image
                                            src={config.apiBaseUrl + row}
                                            alt={row.title}
                                            className="w-8 h-8 object-cover rounded"
                                            width={60}
                                            height={50}
                                        />
                                    )
                                },
                                {
                                    title: 'عنوان دوره',
                                    dataIndex: 'title',
                                    key: 'title',
                                    align: 'right',
                                    className: 'font-custom',
                                    filterDropdown: () => (
                                        <div style={{ padding: 8 }} className="font-custom">
                                            <Space.Compact style={{ width: '100%' }}>
                                                <Input
                                                    className="font-custom"
                                                    placeholder="جستجوی عنوان دوره"
                                                    allowClear
                                                    onClear={() => {
                                                        setCourseSearchFilter((prevState) => ({
                                                            ...prevState,
                                                            title: "",
                                                        }));
                                                    }}
                                                    value={courseSearchFilter.title}
                                                    onChange={(e) => {
                                                        handleCourseSearchChange(e, "title");
                                                    }}
                                                    onPressEnter={() => {
                                                        courseSearch();
                                                    }}
                                                />
                                                <Button type="primary"
                                                    icon={<SearchOutlined />}
                                                    onClick={() => {
                                                        courseSearch();
                                                    }}
                                                />
                                            </Space.Compact>
                                        </div>
                                    ),
                                    render: (text) => <Text strong>{text}</Text>,
                                },
                                {
                                    title: 'قیمت',
                                    dataIndex: 'price',
                                    key: 'price',
                                    align: 'right',
                                    className: 'font-custom ',
                                    render: (price) => <Text className='font-custom' dir='rtl'>{price.toLocaleString()} تومان </Text>,
                                },
                                {
                                    title: 'تعداد ویدیوها',
                                    dataIndex: 'videoCount',
                                    key: 'videoCount',
                                    align: 'center',
                                    className: 'font-custom ',
                                },
                                {
                                    title: 'عملیات',
                                    key: 'action',
                                    align: 'center',
                                    render: (_, record) => {
                                        const isSelected = selectedCourseDetails.some(c => c.courseId === record.courseId);
                                        return (
                                            <Button
                                                type="primary"
                                                icon={<PlusOutlined />}
                                                onClick={() => handleAddCourse(record)}
                                                disabled={isSelected}
                                                className="font-custom"
                                            >
                                                {isSelected ? 'انتخاب شده' : 'افزودن'}
                                            </Button>
                                        )
                                    }
                                }
                                ,
                            ]}
                            dataSource={allCourses}
                            rowKey="courseId"
                            pagination={{
                                current: coursePagination.current,
                                pageSize: coursePagination.pageSize,
                                total: coursePagination.total,
                                onChange: (page, pageSize) => {
                                    setCoursePagination(prev => ({ ...prev, current: page, pageSize }));
                                    fetchCoursesWithFilters(courseSearchFilter.title, page, pageSize);
                                },
                            }}
                            loading={loading || courseLoading}
                        />
                    </div>

                    <div className="mt-6">
                        <div className="flex items-center my-8">
                            <div className="flex-grow border-t border-gray-300"></div>
                            <h2 className="mx-4 text-xl font-bold text-gray-400 whitespace-nowrap font-custom">
                            انتخاب کاربران
                            </h2>
                            <div className="flex-grow border-t border-gray-300"></div>
                        </div>
                        <div className="mb-3 flex justify-start">
                            <SelectUsersExcelButton
                                onSelected={(newUsers) => {
                                    setAllUsers(prev => {
                                        const map = new Map(prev.map(u => [u.userID, u]));
                                        newUsers.forEach(u => map.set(u.userID, u));
                                        return Array.from(map.values());
                                    });
                                    setUsers(prev => {
                                        const map = new Map(prev.map(u => [u.userID, u]));
                                        newUsers.forEach(u => map.set(u.userID, u));
                                        return Array.from(map.values());
                                    });
                                    setSelectedUsers(prev => {
                                        const map = new Map(prev.map(id => [id, id]));
                                        newUsers.forEach(u => map.set(u.userID, u.userID));
                                        const final = Array.from(map.values());
                                        setFormData(f => ({ ...f, userIds: final }));
                                        return final;
                                    });
                                }}
                            />
                        </div>
                        <Table
                            rowSelection={{
                                selectedRowKeys: selectedUsers,
                                onChange: handleUserSelection,
                                fixed: 'left',
                            }}
                            columns={[
                                {
                                    title: 'نام خانوادگی',
                                    dataIndex: 'lastname',
                                    key: 'lastname',
                                    align: 'right',
                                    className: 'font-custom',
                                    filterDropdown: () => (
                                        <div style={{ padding: 8 }} className="font-custom">
                                            <Space.Compact style={{ width: '100%' }}>
                                                <Input
                                                    placeholder="جستجوی نام خانوادگی"
                                                    allowClear
                                                    className="font-custom"
                                                    onClear={() => {
                                                        setUserSearchFilters((prevState) => ({
                                                            ...prevState,
                                                            lastname: "",
                                                        }));
                                                    }}
                                                    value={UserSearchFilters.lastname}
                                                    onChange={(e) => {
                                                        handleUserSearchChange(e, "lastname");
                                                    }}
                                                    onPressEnter={() => {
                                                        userSearch();
                                                    }}
                                                />
                                                <Button type="primary"
                                                    icon={<SearchOutlined />}
                                                    onClick={() => {
                                                        
                                                        userSearch();
                                                    }}
                                                />
                                            </Space.Compact>
                                        </div>
                                    ),
                                },
                                {
                                    title: 'نام کاربری',
                                    dataIndex: 'username',
                                    key: 'username',
                                    align: 'right',
                                    className: 'font-custom'
                                    , filterDropdown: () => (
                                        <div style={{ padding: 8 }} className="font-custom">
                                            <Space.Compact style={{ width: '100%' }}>
                                                <Input
                                                    placeholder="جستجوی نام کاربری"
                                                    allowClear
                                                    className="font-custom"
                                                    onClear={() => {
                                                        setUserSearchFilters((prevState) => ({
                                                            ...prevState,
                                                            username: "",
                                                        }));
                                                    }}
                                                    value={UserSearchFilters.username}
                                                    onChange={(e) => {
                                                        handleUserSearchChange(e, "username");
                                                    }}
                                                    onPressEnter={() => {
                                                        userSearch();
                                                    }}
                                                />
                                                <Button type="primary"
                                                    icon={<SearchOutlined />}
                                                    onClick={() => {
                                                        userSearch();
                                                    }}
                                                />
                                            </Space.Compact>
                                        </div>
                                    ),
                                },
                                {
                                    title: 'کد ملی',
                                    dataIndex: 'personalId',
                                    key: 'personalId',
                                    align: 'center',
                                    className: 'font-custom',
                                    filterDropdown: () => (
                                        <div style={{ padding: 8 }} className="font-custom">
                                            <Space.Compact style={{ width: '100%' }}>
                                                <Input
                                                    placeholder="جستجوی کدملی"
                                                    allowClear
                                                    className="font-custom"
                                                    onClear={() => {
                                                        setUserSearchFilters((prevState) => ({
                                                            ...prevState,
                                                            personalId: "",
                                                        }));
                                                    }}
                                                    value={UserSearchFilters.personalId}
                                                    onChange={(e) => {
                                                        handleUserSearchChange(e, "personalId");
                                                    }}
                                                    onPressEnter={() => {
                                                        userSearch();
                                                    }}
                                                />
                                                <Button type="primary"
                                                    icon={<SearchOutlined />}
                                                    onClick={() => {
                                                        userSearch();
                                                    }}
                                                />
                                            </Space.Compact>
                                        </div>
                                    ),
                                },
                                {
                                    title: 'شماره تلفن',
                                    dataIndex: 'phoneNumber',
                                    key: 'phoneNumber',
                                    align: 'center',
                                    className: 'font-custom',
                                    filterDropdown: () => (
                                        <div style={{ padding: 8 }} className="font-custom">
                                            <Space.Compact style={{ width: '100%' }}>
                                                <Input
                                                    placeholder="جستجوی شماره تلفن"
                                                    allowClear
                                                    className="font-custom"
                                                    onClear={() => {
                                                        setUserSearchFilters((prevState) => ({
                                                            ...prevState,
                                                            personalId: "",
                                                        }));
                                                    }}
                                                    value={UserSearchFilters.phoneNumber}
                                                    onChange={(e) => {
                                                        handleUserSearchChange(e, "phoneNumber");
                                                    }}
                                                    onPressEnter={() => {
                                                        userSearch();
                                                    }}
                                                />
                                                <Button type="primary"
                                                    icon={<SearchOutlined />}
                                                    onClick={() => {
                                                        userSearch();
                                                    }}
                                                />
                                            </Space.Compact>
                                        </div>
                                    ),
                                },
                            ]}
                            dataSource={allUsers}
                            rowKey="userID"
                            pagination={{
                                current: userPagination.current,
                                pageSize: userPagination.pageSize,
                                total: userPagination.total,
                                onChange: (page, pageSize) => {
                                    setUserPagination(prev => ({ ...prev, current: page, pageSize }));
                                    fetchUsersWithFilters(userSearchTerm, page, pageSize);
                                },
                            }}
                            loading={loading}
                        />
                    </div>

                    <button
                        type="submit"
                        disabled={isSubmitting || isOutdated}
                        className="w-full flex justify-center items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-lg text-sm px-4 py-2.5 transition-colors duration-300 disabled:opacity-70"
                    >
                        {isSubmitting ? "در حال ارسال..." : isUpdateMode ? "ویرایش بسته" : "ایجاد بسته"}
                    </button>
                </form>
            </div>

            <VersionConflictModal
                open={versionConflict.open}
                message={versionConflict.message}
                refreshing={isRefreshing}
                onRefresh={handleVersionConflictRefresh}
                onCancel={handleVersionConflictCancel}
            />

            <ToastContainer
                position="bottom-center"
                autoClose={5000}
                theme="dark"
                transition={Bounce}
                className="rtl font-custom"
            />
        </div>
    );
};

export default PackageForm;
